/* ============================================================
   CATERPY CUSTOMER VOICES - シンプルスワイプ
   - 自由にスワイプできる
   - 自動ループはしない（普通のカルーセル）
   ============================================================ */

(function () {
  'use strict';
  // 何もしない。CSSのscroll-snapに任せる。
})();